import anime from "animejs/lib/anime.es.js";

export default {
    changeColor(eleId, fromColor, toColor, duration) {
        anime({
            targets: "#" + eleId,
            color: [fromColor, toColor],
            duration: duration || 200,
            easing: 'easeOutCirc'
        });
    },
    rippleTransition(
        targetId,
        rippleId,
        duration,
        scaleFrom,
        scaleTo,
        color,
        radialImage,
        centerPosition,
        hideRippleAfterComplete,
        completeCallback) {
        if (!rippleId) {
            //Share the same "rippleAnimation" element with "RippleTransition.vue" for now
            rippleId = "rippleAnimation"
        }

        let target = document.getElementById(targetId)
        let ripple = document.getElementById(rippleId)
        let targetInfo = target.getBoundingClientRect();

        if (centerPosition) {
            let divSize = 56;

            let centerPoint = {
                x: (window.innerWidth - divSize) / 2,
                y: (window.innerHeight - divSize) / 2
            };

            ripple.style.left = centerPoint.x + "px";
            ripple.style.top = centerPoint.y + "px";
            ripple.style.width = divSize + "px";
            ripple.style.height = divSize + "px";
        } else {
            ripple.style.left = targetInfo.left + "px";
            ripple.style.top = targetInfo.top + "px";
            ripple.style.width = targetInfo.width + "px";
            ripple.style.height = targetInfo.height + "px";
        }

        if (color) {
            ripple.style.backgroundColor = color;
            ripple.style.backgroundImage = null;
        }
        else if (radialImage) {
            ripple.style.backgroundImage = radialImage;
        }
        else {
            let backgroundColor = getComputedStyle(target).backgroundColor;
            let color = getComputedStyle(target).color;
            let rippleColor =
                backgroundColor === "rgba(0, 0, 0, 0)" ? color : backgroundColor;
            ripple.style.backgroundColor = rippleColor;
        }

        ripple.style.transform = "scale(" + scaleFrom + ")";
        ripple.style.zIndex = 2;
        ripple.style.opacity = 1;

        anime({
            targets: "#" + rippleId,
            scale: scaleTo,
            duration: duration,
            easing: "easeInCirc",
            complete: function () {
                if (completeCallback) {
                    completeCallback();
                }

                if (hideRippleAfterComplete) {
                    anime({
                        targets: "#" + rippleId,
                        opacity: 0,
                        duration: 100,
                        easing: "linear",
                        complete: function () {
                            ripple.style.zIndex = -1;
                        }
                    });
                }
                else {
                    ripple.style.zIndex = 1;
                }
            }
        });
    }
}